import { EnvironmentType } from '@env/environment.type';

export const environment: EnvironmentType = {
  env: 'dev',
  baseUrl: 'https://int-api-v2-clientes.acciona-energia.com',
  oneLoginIssuer: 'https://acciona-sb.onelogin.com/oidc/2',
  oneLoginClientId: 'ca506b90-2eb3-013c-df90-7672a17da9ed38690',
  oidcRedirect: 'https://int-v2-clientes.acciona-energia.com/comercializadora',
  oidcScope: 'openid profile email',
  azureClientId: '5b886a91-344d-42f7-a38f-20193986cf47',
  azureIssuer: 'https://login.microsoftonline.com/f5fd9e16-114f-4820-8de1-6312daf9aebb/v2.0',
  analyticsId: 'G-M9CDLL7GZ3',
};

// import { EnvironmentType } from '@env/environment.type';

// export const environment: EnvironmentType = {
//   env: 'pre',
//   baseUrl: 'https://pre-api-clientes.acciona-energia.com',
//   oneLoginIssuer: 'https://acciona-sb.onelogin.com/oidc/2',
//   oneLoginClientId: '39e13910-2eb6-013c-b360-32e11faebeb638690',
//   oidcRedirect: 'https://pre-clientes.acciona-energia.com/comercializadora',
//   oidcScope: 'openid profile email',
//   azureClientId: '64bb3c61-d7d2-42eb-9fb3-82ebdf5e8117',
//   azureIssuer: 'https://login.microsoftonline.com/f5fd9e16-114f-4820-8de1-6312daf9aebb/v2.0',
//   analyticsId: 'G-Z2DWH8MF87',
// };
